<template>
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: stretch">
        <div style="flex-grow: 0; height: auto; padding: 10px; display: flex;">
            <search-bar
                    reactivity="input"
                    v-model="search" placeholder="검색"></search-bar>
            <v-spacer></v-spacer>
            <agent-version-deploy-button :selected="selected">
            </agent-version-deploy-button>
        </div>
        <div style="flex-grow: 1; height: 100%;">
            <vue-data-table
                    ref="dataTable"
                    v-model="selected"
                    :search="search"
                    :headers="headers"
                    :items="itemsMapped"
                    item-key="raw.rentalcompanyId"
                    show-select
            >
            </vue-data-table>
        </div>
    </div>
</template>

<script>
    import VueDataTable from "@/assets/plugins/vue-data-table/VueDataTable";
    import {PATH} from "@/constants";
    import {dateHelper} from "@/assets/plugins/mps-common/time/date-helper";
    import SearchBar from "@/components/input/SearchBar";
    import AgentDeployVersion from "@/model/agent-deploy-version";
    import AgentVersionDeployButton from "@/views/monitoring/part/AgentVersionDeployButton";

    export default {
        name: "MonitoringAgentDeployByRentalcompany",
        components: {AgentVersionDeployButton, SearchBar, VueDataTable},
        data() {
            return {
                selected: [],
                items: [],
                search: undefined,
                headers: [
                    {
                        text: "국가",
                        value: "raw.countryName",
                        width: 200,
                    },
                    {
                        text: "임대사업자",
                        value: "raw.rentalcompanyName",
                        read: (v, item) => v + " [" + item.raw.rentalcompanyId + "]",
                        width: 500,
                    },
                    {
                        text: "PC Agent version",
                        value: "raw.pcVer",
                        width: 200,
                    },
                    {
                        text: "Tnbox Agent version",
                        value: "raw.dvVer",
                        width: 200,
                    },
                    {
                        text: "PC 등록일",
                        value: "raw.pcRegDatetime",
                        read: (v, item) => dateHelper.formatDateTime(v),
                        width: 200,
                    },
                    {
                        text: "PC 등록자",
                        value: "raw.pcRegister",
                        width: 100,
                    },
                    {
                        text: "DV 등록일",
                        value: "raw.dvRegDatetime",
                        read: (v, item) => dateHelper.formatDateTime(v),
                        width: 200,
                    },
                    {
                        text: "DV 등록자",
                        value: "raw.dvRegister",
                        width: 100,
                    },
                ],
            }
        },
        computed: {
            itemsComputed() {
                const obj = {};
                this.items.forEach(e => {
                    const key = e.rentalcompanyId;
                    // 해당 국가에 대한 오브젝트를 생성합니다.
                    if (!obj[key]) {
                        obj[key] = {};
                        obj[key].rentalcompanyId = e.rentalcompanyId;
                        obj[key].rentalcompanyName = e.rentalcompanyName;
                        obj[key].countryName = e.countryName;
                        obj[key].countryCode = e.countryCode;
                    }

                    // 해당 국가에 대한 PC, DV 버전의 Min Version - Max Version 문자열을 저장합니다.
                    if (e.codeKey.toUpperCase() === "PC") {
                        obj[key].pcVer = e.version;
                        obj[key].pcRegDatetime = e.regDatetime;
                        obj[key].pcRegister = e.register;
                    } else if (e.codeKey.toUpperCase() === "DV") {
                        obj[key].dvVer = e.version;
                        obj[key].dvRegDatetime = e.regDatetime;
                        obj[key].dvRegister = e.register;
                    }
                });

                let arr = [];
                Object.keys(obj).forEach(key =>
                    arr.push({
                        rentalcompanyId: obj[key].rentalcompanyId,
                        rentalcompanyName: obj[key].rentalcompanyName,
                        countryName: obj[key].countryName,
                        countryCode: obj[key].countryCode,
                        pcVer: obj[key].pcVer,
                        dvVer: obj[key].dvVer,
                        pcRegDatetime: obj[key].pcRegDatetime,
                        pcRegister: obj[key].pcRegister,
                        dvRegDatetime: obj[key].dvRegDatetime,
                        dvRegister: obj[key].dvRegister,
                    })
                );

                return arr;
            },

            itemsMapped() {
                return this.itemsComputed.map(e => new AgentDeployVersion(e, "rentalcompany"));
            },
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                const res = await this.$request(PATH.MONITORING.AGENT_VERSION_BY_RENTALCOMPANY)
                    .setObject({})
                    .catch()
                    .enqueue();
                this.items = res.data;
            },
        },
    }
</script>

<style scoped>

</style>